import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global interceptor: if backend responds 403 with detail=USER_INACTIVE,
// the account has been suspended. Redirect to login with a flag so we can
// show a clear message to the ex-nurse.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && detail === "USER_INACTIVE") {
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.replace("/login?suspended=1");
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Ocurrio un error. Intenta de nuevo.";
  if (typeof detail === "string") {
    // Translate our machine code into human message for the login screen
    if (detail === "USER_INACTIVE") {
      return "Tu acceso fue suspendido. Contacta al coordinador de Ciudad Enfermeria.";
    }
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
